module.exports = __webpack_public_path__ + "img/stage-7.eeb51e26.png";